// extracted by mini-css-extract-plugin
export default {"banner":"Banner_banner__9TaV2","container":"Banner_container__kvURj","content":"Banner_content__EhaOT","title":"Banner_title__WH4ce","text":"Banner_text__mu404"};